/* eslint-disable no-nested-ternary,import/no-unresolved */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from 'react-query';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import lodash from 'lodash';

import { isMobile } from 'react-device-detect';
import { AccountDetailsContent, EmptyAccountTransactionsImage } from 'assets/components';
import { TransactionItemPlaceholder } from '../../components/Placeholders';
import WalletDepositModal from './modals/WalletsWithdrawDepositModal';
import SendCryptoModal from './modals/SendCryptoModal';
import { currencies } from '../../utilities/constants';
import { formatNumber, formatNumberWithComma } from '../../utilities/formatHelpers';
import { showAlert } from '../../utilities/notifications';
import {
  RATES_QUERY_KEY,
  USER_PREFERENCES,
  SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
} from '../../utilities/sharedQueries';
import AccountLayout from '../shared/AccountLayout';
import { getTotalBalance } from './partials/helpers';
import { WALLETS_ALL } from './queries';
import { TRANSACTIONS_ALL } from './mutations';
import TransactionModal from './modals/TransactionDetailsModal';
import Calendar from '../../components/Calendar';
import { walletCurrenciesTypes } from './constants';
import {
  useLedgerFilteredCurrencies,
  useLedgerFilteredWallets,
} from '../../utilities/sharedHooks/ledgerWallets';
import ExchangeModal from './modals/exchangeModal';
import { WalletsTypes } from '../Card/constants';
import { useAccountRestriction } from '../../utilities/sharedHooks/account';

import AddAccount from './partials/AddAccount';
import { GET_ALL_STAKINGS } from '../Staking/queries';
import { featuresScreens, mainStakingCurrency, stakingTypes } from '../Staking/constants';
import { useUserAllowStakingFeature, useUserPersonalInfo } from '../../utilities/sharedHooks/user';
import { useLedgerAccounts } from '../../utilities/sharedHooks/ledgerSDKHooks';

const DATE_FORMAT = 'DD MMM YYYY';
const DATE_FULLMONTH_FORMAT = 'DD MMMM YYYY';

const US_DATE_FORMAT = 'MM DD YYYY';
const US_DATE_FULLMONTH_FORMAT = 'MMMM DD YYYY';

const AccountDetails = () => {
  const { coin } = useParams();
  const history = useHistory();
  const [ledgerAccounts] = useLedgerAccounts();
  const [wallet, setWallet] = useState(null);
  const [totalBalanceInFiat, setTotalBalanceInFiat] = useState(0);
  const [totalChangeInFiat, setTotalChangeInFiat] = useState(0);
  const { data: userPref } = useQuery(USER_PREFERENCES);
  const fiatCurrencyCode = userPref?.displayCurrency || 'EUR';

  const { isUS } = useUserPersonalInfo();

  const isDepositHidden = useMemo(
    () => process.env.REACT_APP_DEPOSIT_BUTTON_HIDDEN && !isUS && !['usdc', 'euroc'].includes(coin),
    [coin, isUS]
  );

  const [searchObj, setSearchObj] = useState({
    term: '',
    typing: false,
    typingTimout: 0,
  });

  const [calendarFilter, updateCalendarFilter] = useState({
    fromDate: null,
    toDate: null,
  });

  const {
    refetch: refetchRates,
    isLoading: isRatesLoading,
    data: rates,
  } = useQuery(RATES_QUERY_KEY, {
    onSettled(_, error) {
      if (error) {
        showAlert({ message: error.message, type: 'danger' });
      }
    },
  });

  const [currenttransactionsPage, setCurrentTransactionsPage] = useState(0);
  const [prevtransactionsPage, setPrevTransactionsPage] = useState(-1);

  const [transactions, setTransactions] = useState(null);
  const [isfetchMoreTransactions, setIsFetchMoreTransactions] = useState(true);

  const allowStakingFeature = useUserAllowStakingFeature();

  const showStakingfeature = allowStakingFeature && coin === mainStakingCurrency;

  const {
    data: allStakings,
    refetch: refetchAllStaking,
    isLoading: isLoadingAllStaking,
  } = useQuery(GET_ALL_STAKINGS, {
    enabled: false,
  });

  const resetTransactions = () => {
    setTransactions([]);
    setCurrentTransactionsPage(0);
    setPrevTransactionsPage(-1);
    setIsFetchMoreTransactions(true);
  };

  const { mutate: refetchAllTransactions, isLoading: isTransactionsLoading } = useMutation(
    TRANSACTIONS_ALL,
    {
      onSettled(data, error) {
        const { transactions: transactionList } = data;
        if (error) {
          showAlert({ message: error.message, type: 'danger' });
        } else if (!data) {
          setIsFetchMoreTransactions(false);
        } else if (transactionList && transactionList.length > 0) {
          setPrevTransactionsPage(currenttransactionsPage);
          setTransactions((prev) => [...(prev || []), ...transactionList]);
        } else {
          setIsFetchMoreTransactions(false);
        }
      },
      enabled: false,
    }
  );

  const stakingAmount = useMemo(() => {
    if (allStakings && allStakings?.length > 0) {
      return allStakings
        .filter((item) => item.state === stakingTypes.ACTIVE)
        .reduce((acc, item) => acc + parseFloat(item.amount), 0);
    }
    return 0;
  }, [allStakings]);

  const renderedList = useMemo(() => {
    const getDate = (item) =>
      moment(item.transaction_date).format(isUS ? US_DATE_FORMAT : DATE_FORMAT);
    return lodash(transactions).groupBy(getDate).value();
  }, [transactions]);

  const { refetch: refetchAllWallets, isFetching: isFetchingWallets } = useLedgerFilteredWallets(
    WALLETS_ALL,
    {
      onSettled(data, error) {
        if (error) {
          showAlert({ message: error.message, type: 'danger' });
        }
        const currentWallet = data?.find((w) => w.coin.toLowerCase() === coin?.toLowerCase());
        if (currentWallet) {
          setWallet(currentWallet);
          refetchAllTransactions({
            ...currentWallet,
            page: currenttransactionsPage,
          });
          const { totalBalanceInFiat: balanceInFiat, totalChangeInFiat: changeInFiat } =
            getTotalBalance(
              fiatCurrencyCode,
              currentWallet ? [currentWallet] : [],
              rates,
              showStakingfeature ? stakingAmount : 0
            );

          setTotalBalanceInFiat(balanceInFiat);
          setTotalChangeInFiat(changeInFiat);
        }
      },
    }
  );

  const ledgerAccount = ledgerAccounts[coin?.toLowerCase()];

  const { t: translate } = useTranslation();
  const [isDeposit, setIsDeposit] = useState(false);
  const [showDepositModal, setShowDepositModal] = useState(false);
  const { receiveDisabled, sendDisabled, exchangeDisabled } = useAccountRestriction(
    coin?.toLowerCase()
  );

  const { data: supportedCurrencies, isLoading: isLoadingSupportedCurrencies } =
    useLedgerFilteredCurrencies([SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY]);

  const isCryptoWallet = wallet?.wallet_type?.toLowerCase() === walletCurrenciesTypes.CRYPTO;
  const isStableCoin = wallet?.is_stablecoin;

  const displayCurrencyOnMobile = isCryptoWallet || (!isCryptoWallet && wallet?.is_stablecoin);

  const [showSendCryptoModal, setShowSendCryptoModal] = useState(false);
  const toggleSendCryptoModal = () => setShowSendCryptoModal((prev) => !prev);
  const handleSendCryptoClick = () => {
    toggleSendCryptoModal();
  };

  const [showExchangeModal, setShowExchangeModal] = useState(false);
  const toggleExchangeModal = () => {
    if (showExchangeModal) resetTransactions();
    setShowExchangeModal((prev) => !prev);
  };
  const handleExchangeClick = () => toggleExchangeModal();
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isCalendarVisible, setCalendarVisible] = useState(false);
  const [showSearchInput, setShowSearchInput] = useState(false);

  const toggleSearchInput = () => {
    setShowSearchInput((prev) => !prev);
  };

  const availableBalance = formatNumber(
    wallet?.available_balance * currencies[coin].conversion,
    currencies[coin].decimal
  );

  const listInnerRef = useRef();

  const refreshBalances = () => {
    resetTransactions();
    refetchRates();
  };

  useEffect(() => {
    refetchAllWallets();
  }, [stakingAmount]);

  const totalBXXBalance = useMemo(() => {
    if (showStakingfeature) {
      return formatNumberWithComma(
        formatNumber(
          (parseFloat(wallet?.available_balance) + stakingAmount) * currencies[coin].conversion,
          currencies[coin].decimal
        )
      );
    }
    return 0;
  }, [showStakingfeature, wallet, stakingAmount]);

  useEffect(() => {
    if (showStakingfeature) {
      refetchAllStaking();
    }
  }, [showStakingfeature]);

  useEffect(() => {
    if (
      wallet &&
      isfetchMoreTransactions &&
      prevtransactionsPage !== currenttransactionsPage &&
      !isTransactionsLoading
    ) {
      refetchAllTransactions({
        ...wallet,
        page: currenttransactionsPage,
        from_date: calendarFilter?.fromDate,
        to_date: calendarFilter?.toDate,
        searchQuery: searchObj?.term,
      });
    }
  }, [
    currenttransactionsPage,
    isfetchMoreTransactions,
    prevtransactionsPage,
    isTransactionsLoading,
    wallet,
  ]);

  const changesPercentage = (totalChangeInFiat * 100) / totalBalanceInFiat;

  const handleSearchInputChange = (e) => {
    if (searchObj.typingTimout) {
      clearTimeout(searchObj.typingTimout);
    }

    if (e?.key === 'e' || e?.key === 'E') {
      e.preventDefault();
    } else if (!e || !e?.target || !e?.target?.value) {
      setSearchObj({ term: '', typingTimout: 0 });
      resetTransactions();
    } else {
      setSearchObj({
        term: e.target.value,
        typingTimout: setTimeout(() => {
          resetTransactions();
        }, 1000),
      });
    }
  };

  const selectedFromDate = moment(calendarFilter.fromDate);
  const selectedToDate = moment(calendarFilter.toDate);

  const renderDateRange = () => {
    let dateRange = '';
    if (selectedFromDate.format('MMMM YYYY') === selectedToDate.format('MMMM YYYY')) {
      dateRange = isUS
        ? `${selectedFromDate.format('MMMM DD')} - ${selectedToDate.format('DD YYYY')}`
        : `${selectedFromDate.format('DD')} - ${selectedToDate.format(DATE_FULLMONTH_FORMAT)}`;
    } else if (selectedFromDate.format('YYYY') === selectedToDate.format('YYYY')) {
      dateRange = isUS
        ? `${selectedFromDate.format('MMMM DD')} - ${selectedToDate.format(
            US_DATE_FULLMONTH_FORMAT
          )}`
        : `${selectedFromDate.format('DD MMMM')} - ${selectedToDate.format(DATE_FULLMONTH_FORMAT)}`;
    } else {
      dateRange = isUS
        ? `${selectedFromDate.format(US_DATE_FULLMONTH_FORMAT)} - ${selectedToDate.format(
            US_DATE_FULLMONTH_FORMAT
          )}`
        : `${selectedFromDate.format(DATE_FULLMONTH_FORMAT)} - ${selectedToDate.format(
            DATE_FULLMONTH_FORMAT
          )}`;
    }
    return dateRange;
  };

  const renderFilter = () => (
    <div className="d-none d-md-flex justify-content-between align-items-center">
      <div className="form-group mt-auto mb-auto p-0">
        <input
          value={searchObj?.term}
          onChange={(e) => handleSearchInputChange(e)}
          onKeyDown={() => {}}
          name="search"
          type="number"
          className="form-control-search ps-5 bg-light text-white border-1 border-transparent"
          placeholder={translate('search_transactions_placeholder')}
          tabIndex={0}
        />
        <span className="icon-search icon-search-other text-white" />
      </div>
      <div className="d-flex flex-row align-items-center">
        <i
          aria-label="calendar"
          role="button"
          tabIndex={-1}
          onKeyDown={() => {}}
          className={`icon-calendar-navigation ${
            calendarFilter.fromDate || calendarFilter.toDate ? 'text-primary' : 'text-white'
          } text-f4 text-hover-dimmed`}
          onClick={() => setCalendarVisible(true)}
        />
        <span className="ms-2">
          {calendarFilter.fromDate && calendarFilter.toDate && renderDateRange()}
        </span>
      </div>
    </div>
  );

  const onDepositClick = () => {
    setShowDepositModal(true);
    setIsDeposit(true);
  };

  const handleWithdrawFiatClick = () => {
    setShowDepositModal(true);

    setIsDeposit(false);
  };

  const renderAddFundButton = () => (
    <button
      disabled={receiveDisabled}
      className="text-f6 btn-link flex-grow-1 m-0 p-0 text-nowrap text-primary details-action-button border-primary"
      onClick={() => {
        onDepositClick();
      }}
      type="button">
      <div
        className={`d-md-none d-flex rounded-circle position-relative ${
          receiveDisabled ? 'bg-disabled' : 'bg-primary'
        } mb-1 justify-content-center align-items-center`}
        style={{ width: '3.5rem', height: '3.5rem' }}>
        <i className="icon-deposit-card h1 text-white position-absolute top-50 start-50 translate-middle fw-light" />
      </div>
      <b className={`details-action-button-title ${receiveDisabled ? 'text-shadow' : ''}`}>
        {translate('add_funds_btn_title')}
      </b>
    </button>
  );

  const renderSendOrWithdrawalButton = (type) => (
    <button
      disabled={sendDisabled}
      className="p-0 text-f6 flex-grow-1 btn-link  m-0 details-action-button"
      onClick={type === WalletsTypes.CRYPTO ? handleSendCryptoClick : handleWithdrawFiatClick}
      type="button">
      <div
        className={`d-md-none d-flex rounded-circle position-relative ${
          sendDisabled ? 'bg-disabled' : 'bg-primary'
        } mb-1 justify-content-center align-items-center`}
        style={{ width: '3.5rem', height: '3.5rem' }}>
        <i className="icon-withdraw-card h1 text-white position-absolute top-50 start-50 translate-middle fw-light" />
      </div>
      <b className={`details-action-button-title ${sendDisabled ? 'text-shadow' : ''}`}>
        {type === WalletsTypes.CRYPTO || isStableCoin
          ? translate('send_button_label')
          : translate('withdraw_button_label')}
      </b>
    </button>
  );

  const renderExchangeButton = () => (
    <button
      className={`p-0 m-0 text-f6 btn-link flex-grow-1 ${
        exchangeDisabled ? 'text-shadow' : 'text-primary'
      } details-action-button`}
      disabled={exchangeDisabled}
      onClick={handleExchangeClick}
      type="button">
      <div
        className={`d-md-none d-flex rounded-circle position-relative ${
          exchangeDisabled ? 'bg-disabled' : 'bg-primary'
        } mb-1 justify-content-center align-items-center`}
        style={{ width: '3.5rem', height: '3.5rem' }}>
        <i className="icon-buy-sell-menu h1 text-white position-absolute top-50 start-50 translate-middle fw-light" />
      </div>
      <b className={`details-action-button-title ${exchangeDisabled ? 'text-shadow' : ''}`}>
        {translate('exchange_btn_label')}
      </b>
    </button>
  );

  const renderCryptoActionButtons = () => (
    <div className="d-flex flex-row align-items-center mt-4 justify-content-center">
      {!isDepositHidden && (
        <>
          {renderAddFundButton()}
          <b className="d-none d-md-block text-f5 text-disabled mx-2">|</b>
        </>
      )}
      {renderSendOrWithdrawalButton(WalletsTypes.CRYPTO)}
      <b className="d-none d-md-block text-f5 text-disabled mx-2">|</b>
      {renderExchangeButton()}
    </div>
  );

  const renderFiatActionButtons = () => (
    <div className="d-flex flex-row align-items-center mt-4 justify-content-center">
      {!isDepositHidden && (
        <>
          {renderAddFundButton()}
          <b className="d-none d-md-block text-f5 text-disabled mx-2">|</b>
        </>
      )}
      {renderSendOrWithdrawalButton(WalletsTypes.FIAT)}
      <b className="d-none d-md-block text-f5 text-disabled mx-2">|</b>
      {renderExchangeButton()}
    </div>
  );

  const renderSearchInput = () => (
    <>
      <span
        className="d-flex border rounded-2 p-2 border-disabled"
        role="button"
        tabIndex="0"
        onKeyPress={toggleSearchInput}
        onClick={toggleSearchInput}>
        <img src="./assets/images/close.svg" alt="close" />
      </span>
      <div className="form-group m-0 p-0">
        <input
          value={searchObj?.term}
          onChange={(e) => handleSearchInputChange(e)}
          onKeyDown={() => {}}
          name="search"
          type="number"
          className="form-control-search bg-lighter text-white border-1 border-primary ps-5"
          placeholder={translate('search_transactions_placeholder')}
          tabIndex={0}
        />
        <span className="icon-search icon-search-other text-shadow" />
      </div>
    </>
  );

  const stakingNowHandler = () => {
    if (wallet?.available_balance * currencies[coin].conversion > 0) {
      history.push('/dashboard/staking/features', {
        initScreen: featuresScreens.CREATE_STAKING,
      });
    } else {
      history.push('/dashboard/staking/features', {
        initScreen: featuresScreens.ADD_FUNDS_OPTIONS,
      });
    }
  };

  const renderStakeNowBtn = () => (
    <div className="w-100 mt-4">
      <AddAccount
        label={translate('stake_now_btn_label')}
        subLabel={translate('stake_now_btn_sublabel')}
        onClick={stakingNowHandler}
        icon="STAKING"
        isImg
        imageStyle={{ width: '2.5rem', height: '2.5rem' }}
      />
    </div>
  );

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

      if (
        Math.ceil(scrollTop + clientHeight + 10) >= scrollHeight - 50 &&
        !isTransactionsLoading &&
        isfetchMoreTransactions
      ) {
        setCurrentTransactionsPage((prev) => prev + 1);
      }
    }
  };

  const showEmptyList = useMemo(() => {
    if (
      !isTransactionsLoading &&
      (!transactions || (transactions && Object.keys(renderedList).length === 0))
    ) {
      return true;
    }

    return false;
  }, [transactions, renderedList, isTransactionsLoading]);

  const showEmptySearchResult =
    !!searchObj?.term || !!calendarFilter.toDate || !!calendarFilter.fromDate;

  const renderEmptyList = () => (
    <div className="w-100 d-flex flex-column align-items-center justify-content-center text-center details-empty-list-container">
      <EmptyAccountTransactionsImage showEmptySearchResult={showEmptySearchResult} />
      <p className="mt-2" style={{ fontSize: '1.375rem', fontWeight: 600 }}>
        <b>
          {showEmptyList && !showEmptySearchResult
            ? translate('transactions_empty_label')
            : translate('search_no_results_found_label')}
        </b>
      </p>
      <p className="text-f6 text-shadow mt-2">
        {showEmptyList && !showEmptySearchResult
          ? translate('transactions_empty_sublabel')
          : translate('search_try_different_criteria_label')}
      </p>
    </div>
  );

  const renderFirstLoader = () => (
    <div className="d-flex flex-column mt-3 gap-3">
      <TransactionItemPlaceholder />
      <TransactionItemPlaceholder />
      <TransactionItemPlaceholder />
      <TransactionItemPlaceholder />
      <TransactionItemPlaceholder />
      <TransactionItemPlaceholder />
    </div>
  );

  const isPageLoading =
    isRatesLoading || isLoadingAllStaking || isFetchingWallets || isLoadingSupportedCurrencies;

  return (
    <>
      <AccountLayout
        withBack
        title={
          wallet
            ? translate('transactions_title').replace('%s', wallet?.coin?.toUpperCase() || '')
            : ''
        }
        centerTitleOnMobile={isMobile}
        renderFilter={wallet ? renderFilter : null}
        browserChildren={
          <AccountDetailsContent
            ref={listInnerRef}
            calendarFilter={calendarFilter}
            refreshBalances={refreshBalances}
            showStakingfeature={showStakingfeature}
            changesPercentage={changesPercentage}
            displayCurrencyOnMobile={displayCurrencyOnMobile}
            totalBalanceInFiat={totalBalanceInFiat}
            totalChangeInFiat={totalChangeInFiat}
            fiatCurrencyCode={fiatCurrencyCode}
            coin={coin}
            availableBalance={availableBalance}
            totalBXXBalance={totalBXXBalance}
            stakingAmount={stakingAmount}
            renderFiatActionButtons={renderFiatActionButtons}
            renderCryptoActionButtons={renderCryptoActionButtons}
            isStableCoin={isStableCoin}
            isCryptoWallet={isCryptoWallet}
            renderStakeNowBtn={renderStakeNowBtn}
            wallet={wallet}
            isTransactionsLoading={isTransactionsLoading}
            toggleSearchInput={toggleSearchInput}
            renderedList={renderedList}
            showEmptyList={showEmptyList}
            renderFirstLoader={renderFirstLoader}
            renderEmptyList={renderEmptyList}
            onScroll={onScroll}
            renderSearchInput={renderSearchInput}
            isLoadingFirstTimeVisible={isPageLoading}
            setSelectedTransaction={setSelectedTransaction}
            showSearchInput={showSearchInput}
            setCalendarVisible={setCalendarVisible}
          />
        }
        mobileChildren={
          <AccountDetailsContent
            ref={listInnerRef}
            calendarFilter={calendarFilter}
            refreshBalances={refreshBalances}
            showStakingfeature={showStakingfeature}
            changesPercentage={changesPercentage}
            displayCurrencyOnMobile={displayCurrencyOnMobile}
            totalBalanceInFiat={totalBalanceInFiat}
            totalChangeInFiat={totalChangeInFiat}
            fiatCurrencyCode={fiatCurrencyCode}
            coin={coin}
            availableBalance={availableBalance}
            totalBXXBalance={totalBXXBalance}
            stakingAmount={stakingAmount}
            renderFiatActionButtons={renderFiatActionButtons}
            renderCryptoActionButtons={renderCryptoActionButtons}
            isStableCoin={isStableCoin}
            isCryptoWallet={isCryptoWallet}
            renderStakeNowBtn={renderStakeNowBtn}
            wallet={wallet}
            isTransactionsLoading={isTransactionsLoading}
            toggleSearchInput={toggleSearchInput}
            renderedList={renderedList}
            showEmptyList={showEmptyList}
            renderFirstLoader={renderFirstLoader}
            renderEmptyList={renderEmptyList}
            onScroll={onScroll}
            renderSearchInput={renderSearchInput}
            isLoadingFirstTimeVisible={isPageLoading}
            setSelectedTransaction={setSelectedTransaction}
            showSearchInput={showSearchInput}
            setCalendarVisible={setCalendarVisible}
          />
        }
      />
      {selectedTransaction && (
        <TransactionModal
          transaction={selectedTransaction}
          wallet={wallet}
          hide={() => setSelectedTransaction(null)}
        />
      )}
      <Calendar
        onHide={() => setCalendarVisible(false)}
        isVisible={isCalendarVisible}
        onSubmit={(form) => {
          resetTransactions();
          updateCalendarFilter(form);
        }}
      />
      {showDepositModal && (
        <WalletDepositModal
          hide={() => {
            setShowDepositModal(false);
          }}
          walletsType={wallet?.wallet_type}
          wallet={wallet}
          ledgerAccount={ledgerAccount}
          isDeposit={isDeposit}
        />
      )}
      {showSendCryptoModal && (
        <SendCryptoModal
          hide={toggleSendCryptoModal}
          wallet={wallet}
          ledgerAccount={ledgerAccount}
          fiatCurrencyCode={fiatCurrencyCode}
          onSent={refreshBalances}
        />
      )}
      {showExchangeModal && (
        <ExchangeModal
          wallet={wallet}
          hide={toggleExchangeModal}
          fiatCurrencyCode={fiatCurrencyCode}
          supportedCurrencies={supportedCurrencies}
        />
      )}
    </>
  );
};

export default AccountDetails;
